import { render, staticRenderFns } from "./hours.vue?vue&type=template&id=bda46b12&"
import script from "./hours.vue?vue&type=script&lang=js&"
export * from "./hours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports